import {TypeEntityLinkTo, TypeNav, TypeNavKey } from 'Type'

const HookNavContextOptional = <T extends TypeEntityLinkTo>(key :TypeNavKey, nav? :TypeNav<any>) :T | undefined => {
    return nav?.context[key] as T
}

export default HookNavContextOptional